import { TextField } from '@mui/material';
import PropTypes from 'prop-types';
import { t } from 'i18next';

/**
 * A functional component that renders an email input field.
 */
export const TextFieldEmail = ({ values, handleChange, errors, touched }) => (
    <TextField
        fullWidth
        label={t('users.fields.email')}
        type="email"
        name="email"
        value={values.email}
        error={touched.email && Boolean(errors.email)}
        helperText={touched.email && errors.email}
        onChange={handleChange}
    />
);

TextFieldEmail.propTypes = {
    values: PropTypes.object.isRequired,
    handleChange: PropTypes.func.isRequired,
    errors: PropTypes.object.isRequired,
    touched: PropTypes.object.isRequired
};
